// Copyright © Aptos
// SPDX-License-Identifier: Apache-2.0

import { Network } from '@aptos-labs/ts-sdk';

const devnetBaseUrl = 'https://api.devnet.aptoslabs.com';
const shelbynetBaseUrl = 'https://api.shelbynet.aptoslabs.com';

export const shelbynet = {
  // This is not reliable and might change in future releases, but it's useful to keep around as "unique id" for
  // the frontend
  chainId: 59,
  faucetUrl: 'https://faucet.shelbynet.shelby.xyz',
  indexerUrl: `${shelbynetBaseUrl}/v1/graphql`,
  name: 'shelbynet' as const,
  nodeUrl: `${shelbynetBaseUrl}/v1`,
  // Note: using devnet's keyless services, so we don't have to spin up separate ones
  pepperUrl: `${devnetBaseUrl}/keyless/pepper/v0`,
  proverUrl: `${devnetBaseUrl}/keyless/prover/v0`,
};

export type ExtendedNetwork = Network | typeof shelbynet.name;
